export default function UnlockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_1249_8436)">
        <path
          d="M8.09524 12.1905C8.93333 12.1905 9.61905 11.5048 9.61905 10.6667C9.61905 9.82862 8.93333 9.1429 8.09524 9.1429C7.25714 9.1429 6.57143 9.82862 6.57143 10.6667C6.57143 11.5048 7.25714 12.1905 8.09524 12.1905ZM12.6667 5.33338H11.9048V3.80957C11.9048 1.70671 10.1981 4.57764e-05 8.09524 4.57764e-05C5.99238 4.57764e-05 4.28571 1.70671 4.28571 3.80957H5.73333C5.73333 2.50671 6.79238 1.44766 8.09524 1.44766C9.3981 1.44766 10.4571 2.50671 10.4571 3.80957V5.33338H3.52381C2.68571 5.33338 2 6.01909 2 6.85719V14.4762C2 15.3143 2.68571 16 3.52381 16H12.6667C13.5048 16 14.1905 15.3143 14.1905 14.4762V6.85719C14.1905 6.01909 13.5048 5.33338 12.6667 5.33338ZM12.6667 14.4762H3.52381V6.85719H12.6667V14.4762Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1249_8436">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
